import { NotificationType, useToast } from '@insurgrid/ui';

export function useSuccessHandlers() {
  const { setToast } = useToast();
  const onCreateSuccess = () => {
    setToast({
      type: NotificationType.Success,
      title: 'Successfully added!',
    });
  };

  const onEditSuccess = () => {
    setToast({
      type: NotificationType.Success,
      title: 'Your changes have been saved.',
    });
  };
  return { onCreateSuccess, onEditSuccess };
}
